<template>
  <div class="loading-bar-container">
    <div class="loading-bar">
      <div
        class="loading-progress"
        :style="{ width: displayedPercentage + '%' }"
      ></div>
      <span class="loading-text">
        Returning answer.. {{ displayedPercentage.toFixed(0) }}%
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingBar',
  props: {
    progressValue: {
      type: Number,
      required: true,
      validator: (v) => v >= 0 && v <= 1,
    },
  },
  data() {
    return {
      displayedValue: 0,
      animationFrame: null,
    };
  },
  computed: {
    displayedPercentage() {
      return this.displayedValue * 100;
    },
  },
  watch: {
    progressValue: {
      immediate: true,
      handler(newVal) {
        this.animateTo(newVal);
      },
    },
  },
  methods: {
    animateTo(target) {
      cancelAnimationFrame(this.animationFrame);

      const step = () => {
        const delta = target - this.displayedValue;
        const speed = 0.002; // how fast to approach target (tweakable)

        if (Math.abs(delta) < 0.001) {
          this.displayedValue = target;
          return;
        }

        this.displayedValue += delta * speed;
        this.animationFrame = requestAnimationFrame(step);
      };

      step();
    },
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationFrame);
  },
};
</script>

<style scoped>
.loading-bar-container {
  width: 100%;
  padding: 10px;
  background-color: #f4f4f8;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-bar {
  position: relative;
  width: 80%;
  height: 20px;
  background-color: #e0d7f3;
  border-radius: 10px;
  overflow: hidden;
}

.loading-progress {
  height: 100%;
  background-color: #6a0dad;
  transition: width 0.1s linear;
  border-radius: 10px;
}

.loading-text {
  position: absolute;
  width: 100%;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  pointer-events: none;
}
</style>
